import { hot } from 'react-hot-loader/root';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { GlobalStyles, ThemeProvider, RootContainer } from './components';
import { Landing } from './components/landing';
import { setupConfig, ConfigProvider } from './hooks/config';
import { setupAuth, AuthContextProvider } from './hooks/auth';
import { AuthenticatedAccess } from './components/authenticated-access';
import 'antd/dist/antd.css';
const Root = () => {
    const { error: configError, config } = setupConfig();
    const { error: authError, state: authState } = setupAuth(config);
    return (React.createElement(ThemeProvider, null,
        React.createElement(GlobalStyles, null),
        React.createElement(ConfigProvider, { value: config },
            React.createElement(AuthContextProvider, { value: authState },
                React.createElement(RootContainer, null,
                    React.createElement(AuthenticatedAccess, { authError: authError, configError: configError },
                        React.createElement(Landing, null)))))));
};
const HotRoot = hot(Root);
ReactDOM.render(React.createElement(HotRoot, null), document.getElementById('root'));
//# sourceMappingURL=index.js.map